import { type ReactElement, useState } from 'react';
import { Input } from '@/shared/ui';

interface QuantityInputProps {
  readonly label: string;
  readonly value: number;
  readonly onChange: (quantity: number) => void;
}

/**
 * 수량 입력 — 입력하는 동안은 지운 칸도 그대로 두고(초안), 1 이상 정수가 되면 그때마다 값을 올린다. 칸을 떠날 때 초안을 버리고
 * 마지막으로 올린 유효한 값으로 되돌려, 지웠다 다시 쓸 때 값이 1 로 튀지 않게 한다.
 */
export const QuantityInput = ({ label, value, onChange }: QuantityInputProps): ReactElement => {
  const [draft, setDraft] = useState<string | null>(null);

  return (
    <Input
      type="number"
      min={1}
      step={1}
      aria-label={label}
      className="min-w-24"
      value={draft ?? value}
      onChange={(event) => {
        const text = event.target.value;
        setDraft(text);
        const parsed = Number(text);
        if (text.trim() !== '' && Number.isInteger(parsed) && parsed >= 1) onChange(parsed);
      }}
      onBlur={() => setDraft(null)}
    />
  );
};
